import PropTypes from "prop-types";
import React from "react";
import TextLink from "theme/components/text/TextLink";
import styled from "theme/libs/styled";

const StyledLink = styled(TextLink)`
    display: inline-block;
    color: inherit;

    &:hover {
        color: inherit;
    }
`;

const Url = ({ attrs, children }) => (
    <StyledLink to={attrs["data-url"]} tabIndex={attrs["tabIndex"]} textStyles="inherit">
        {children}
    </StyledLink>
);

Url.propTypes = {
    attrs: PropTypes.object.isRequired,
    children: PropTypes.node.isRequired,
};

export default Url;
